// Must be imported FIRST in index.jsx (before React/antd/maps). ES module
// imports are hoisted and evaluated in order, so a side-effect module at the
// top runs before any library code — including libraries that capture the
// native ResizeObserver reference at module-eval time.
//
// antd tables/tabs/drawers measure layout with ResizeObserver; delivering its
// callbacks on the next animation frame avoids the benign "ResizeObserver loop
// completed with undelivered notifications" error that the CRA dev overlay
// otherwise shows on page-to-page transitions. The overlay registers its error
// listener before app code, so the error can only be stopped at the source.
if (typeof window !== 'undefined' && window.ResizeObserver && !window.ResizeObserver.__wrapped) {
  const NativeResizeObserver = window.ResizeObserver
  class RAFResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer)
          } catch {
            // swallow: a stale antd measurement must never crash the app
          }
        })
      })
    }
  }
  RAFResizeObserver.__wrapped = true
  window.ResizeObserver = RAFResizeObserver
}
